// API 配置文件
export const API_CONFIG = {
  // 基础 URL，优先从运行时环境变量 window.REACT_APP_API_BASE_URL 获取
  // 构建时环境变量 REACT_APP_API_BASE_URL 作为备选
  // 如果都没有则使用默认值
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',

  // API 端点
  ENDPOINTS: {
    // 获取文档列表
    DOCUMENT_LIST: '/document/list',
    // 获取文档详情
    DOCUMENT_DETAIL: '/document/detail',
    // 搜索文档
    DOCUMENT_SEARCH: '/document/search',
    // 文档点击
    DOCUMENT_CLICK: '/document/click',
    // 文档点赞
    DOCUMENT_LIKE: '/document/like',
    // 文档收藏
    DOCUMENT_FAVORITE: '/document/favorite',
    // 标记文档已读
    DOCUMENT_MARK_READ: '/document/mark_read',
    // 标记文档未读
    DOCUMENT_MARK_UNREAD: '/document/mark_unread',
    // 获取 Feed 列表
    FEED_LIST: '/feed/list',
    // 搜索 Feed
    FEED_SEARCH: '/feed/search',
    // 添加 Feed
    FEED_ADD: '/feed/add',
    // 删除 Feed
    FEED_DELETE: '/feed/remove',
    // 获取评论列表
    COMMENT_LIST: '/comment/list',
    // 添加评论
    COMMENT_ADD: '/comment/add',
    // 用户注册
    USER_REGISTER: '/user/register',
    // 用户登录
    USER_LOGIN: '/user/login',
    // 获取用户信息
    USER_INFO: '/user/info',
    // 更新用户信息
    USER_UPDATE: '/user/update',
    // 获取用户收藏列表
    USER_FAVORITES: '/user/favorites',
    // 运行爬虫
    RUN_SPIDER: '/run_spider',
    // 获取热门文档
    DOCUMENT_HOT: '/document/hot',
  },
};
